import { createElement } from '../../../../../../../../core/helpers/dom';

import AbstractDropdown, {
  TCustomDropdownParams,
} from '../../../../../../../components/dropdown/AbstractDropdown';
import { translate } from '../../../../../../../features/translate/translate';
import { iconMap } from '../../../../../../../shared/enums/icon-map';
import { EIconPath } from '../../../../../../../shared/enums/icons.enum';
import { TColumn } from '../../../../../site-table/columns/column.model';
import { GET_COLUMNS } from '../../../../../site-table/columns/columns.store';
import { GET_GROUPING } from '../../../../../site-table/columns/grouping.store';
import { ESortOrder } from '../../../../../site-table/sort-order-enum';

export default class GroupOrSortOrderDropdown extends AbstractDropdown {
  columns: TColumn[] = [];

  columnSectionElement: HTMLElement = null;

  constructor(_dropdownProperties: TCustomDropdownParams) {
    super({
      ..._dropdownProperties,
    });

    const grouping = GET_GROUPING();
    this.columns = GET_COLUMNS();

    grouping.forEach((_sortColumn) => {
      this.columns = this.columns.filter((_column) => _column.name !== _sortColumn.name);
    });

    this.contentElement = this.createContentElement();

    this.init();
  }

  private createContentElement(): HTMLElement {
    return createElement('div', {
      attrs: {
        class: 'groupByDropdown',
      },
      children: [this.createTitleElement(), this.createColumnSectionElement()],
    });
  }

  private createTitleElement(): HTMLElement {
    return createElement('div', {
      attrs: {
        class: 'groupByDropdown__title',
      },
      children: [translate('select_order')],
    });
  }

  private createFieldIcon(order: ESortOrder): HTMLElement {
    const src = order === ESortOrder.ASC ? EIconPath.ICON_MISC_A_Z_18 : EIconPath.ICON_MISC_Z_A_18;

    const iconElementWrapper = createElement('div', {
      attrs: {
        class: 'iconElementWrapper',
      },
    });

    iconElementWrapper.innerHTML = iconMap[src];

    return iconElementWrapper;
  }

  private createColumnSectionElement(): HTMLElement {
    let children = [];

    if (this.columns.length) {
      children = [this.createAscElement(), this.createDescElement()];
    } else {
      children = [this.createNoElementsMessage()];
    }

    this.columnSectionElement = createElement('div', {
      children,
    });

    return this.columnSectionElement;
  }

  private createNoElementsMessage(): HTMLElement {
    const fieldElement = createElement('div', {
      attrs: {
        class: 'dropdownItem dropdownItem__group',
      },
      eventListeners: {},
      children: [translate('no_more_fields_to_choose_from')],
    });

    return fieldElement;
  }

  private createAscElement(): HTMLElement {
    const fieldElement = createElement('div', {
      attrs: {
        class: 'dropdownItem dropdownItem__group',
      },
      eventListeners: {
        click: () => {
          this.onSelect(ESortOrder.ASC);
          this.update();
          this.destroy();
        },
      },
      children: [this.createFieldIcon(ESortOrder.ASC), translate('ascending')],
    });

    return fieldElement;
  }

  private createDescElement(): HTMLElement {
    const fieldElement = createElement('div', {
      attrs: {
        class: 'dropdownItem dropdownItem__group',
      },
      eventListeners: {
        click: () => {
          this.onSelect(ESortOrder.DESC);
          this.update();
          this.destroy();
        },
      },
      children: [this.createFieldIcon(ESortOrder.DESC), translate('descending')],
    });

    return fieldElement;
  }
}
